<template>
  <b-overlay
    :show="show"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <b-card title="Master Device">
      <!-- <b-card-text>Device.</b-card-text> -->
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent>
          <b-row>
            <!-- Type -->
            <b-col cols="12">
              <b-form-group
                label="Type"
                label-for="v-Type"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Type"
                  rules="required"
                >
                  <v-select
                    id="v-Type"
                    v-model="form.select_1"
                    placeholder="Chose Type"
                    autocomplete="off"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="TypeOptions"
                    :reduce="TypeOptions => TypeOptions.value"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Name -->
            <b-col cols="12">
              <b-form-group
                label="Name"
                label-for="v-Name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Name"
                  rules="required"
                >
                  <b-form-input
                    id="v-Name"
                    v-model="form.text_2"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Name"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Kode -->
            <b-col cols="12">
              <b-form-group
                label="Kode"
                label-for="v-Kode"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Kode"
                  rules="required"
                >
                  <b-form-input
                    id="v-Kode"
                    v-model="form.text_2"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Kode"
                    readonly
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Note -->
            <b-col cols="12">
              <b-form-group
                label="Note"
                label-for="v-Note"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Note"
                  rules="required"
                >
                  <b-form-textarea
                    id="v-Note"
                    v-model="form.textarea_1"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Note"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Serial Number -->
            <b-col cols="12">
              <b-form-group
                label="Serial Number"
                label-for="v-Serial Number"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Serial Number"
                  rules="required"
                >
                  <b-input-group>
                    <b-form-input
                      id="v-Serial Number"
                      v-model="form.text_3"
                      type="number"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Serial Number"
                    />
                    <b-input-group-append>
                      <b-button
                        variant="outline-primary"
                        @click="checkBySerialNumber()"
                      >
                        Check
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <small :class="serialclass">{{ serial }}</small>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>

    <b-card title="List Historical">
      <b-table
        striped
        hover
        responsive
        class="position-relative"
        :per-page="perPage"
        :current-page="currentPage"
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
      >
        <template #cell(created_at)="data">
          {{ dateFormat(data.value) }}
        </template>
        <template #cell(logo)="data">
          <b-img
            width="50"
            :src="data.value"
          />
        </template>
        <template #cell(action)="row">
          <b-link
            v-b-modal.modal-center
            @click="rowOnDelete(row.item.id)"
          >
            <feather-icon
              icon="EyeIcon"
              class="mr-50"
            />
          </b-link>
        </template>
      </b-table>
      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <p class="text-nowrap align-left">
          &nbsp;Total Rows {{ totalRows }}
        </p>
        <b-form-group
          label="Per Page"
          label-cols="6"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
          />
        </b-form-group>
        <p class="text-nowrap mb-md-0 mr-1 align-left" />
        <!-- pagination -->
        <div>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BOverlay, BInputGroupAppend, BInputGroup, BCardText, BTable, BPagination, BFormSelect, BCardBody, BFormFile, BMediaBody, BMedia, BMediaAside, BLink, BCol, BFormGroup, BFormCheckbox, BFormInput, BFormTextarea, BForm, BButton, BCard, BImg,
} from 'bootstrap-vue'
import { mapState } from 'vuex'
import { required } from '@validations'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    vSelect, BOverlay, BInputGroupAppend, BInputGroup, BCardText, BFormFile, BMediaBody, BMedia, BMediaAside, BTable, BPagination, BFormSelect, BCardBody, BLink, BFormCheckbox, ValidationProvider, ValidationObserver, BCard, BImg, BRow, BCol, BFormGroup, BFormInput, BFormTextarea, BForm, BButton,
  },
  directives: { Ripple },
  data() {
    return {
      form: {
        id: null, select_1: 6, text_1: '', text_2: '', text_3: '', text_4: '', text_5: '', text_6: '', checkbox_1: false, imageUrl: require('@/assets/images/icons/jpg.png'), setImage: 'none', logo: null,
      },
      currentPage: 1,
      perPage: 10,
      serialclass: null,
      serial: null,
      show: false,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      required,
    }
  },
  computed: {
    ...mapState({
      TypeOptions: state => state.type.options,
      items: state => state.historicalDevice.items,
      fields: state => state.historicalDevice.fields,
      totalRows: state => state.historicalDevice.totalRows,
      pageOptions: state => state.historicalDevice.pageOptions,
    }),
  },
  created() {
    this.$store.dispatch('type/getAll')
  },
  mounted() {
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  },
  methods: {
    validationForm() {
      this.show = true
      this.$refs.simpleRules.validate()
        .then(success => {
          if (success) {
            if (this.serial === 'SUCCESS') {
              const formData = this.form
              this.$store.dispatch('device/formPostPut', formData)
                .then(res => {
                  this.notification('Success', 'CheckIcon', 'success', 'You have successfully')
                },
                err => {
                  this.show = false
                  this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
                })
            } else {
              this.show = false
              this.notification('Failed', 'CloseIcon', 'danger', 'Serial NOT FOUND')
            }
          } else {
            this.show = false
            this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
          }
        })
    },
    notification(a, b, c, d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: a, icon: b, variant: c, text: d,
        },
      })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.$store.state.totalRows = filteredItems.length
      this.currentPage = 1
      this.data[0].title = this.totalRows
    },
    checkBySerialNumber() {
      this.$store.dispatch('device/checkBySerialNumber', this.form.text_3).then(data => {
        // console.log(data)
        if (data.message === 'SUCCESS') {
          this.serialclass = 'text-success'
        } else {
          this.serialclass = 'text-danger'
        }
        this.serial = data.message
      })
    },
    getData(id) {
      this.$store.dispatch('device/getById', id).then(data => {
        this.form.id = data.id
        this.form.select_1 = data.device_type_id
        this.form.text_2 = data.code
        this.form.text_2 = data.name
        this.form.textarea_1 = data.note
        this.form.text_3 = data.serial_number
        this.serial = 'SUCCESS'
        this.show = false
        this.getHistoricalData(data.serial_number)
      })
    },
    getHistoricalData(serialNumber, params) {
      this.$store.dispatch('historicalDevice/getBySerial', { serialNumber, params }).then(data => {})
    },
  },
}
</script>
  <style lang="scss" >
  @import '@core/scss/vue/libs/vue-select.scss';
  </style>
